var Ranking = {

	init: function () {

		var prizes = [
			'30 créditos, 50 monedas web y logro exclusivo.',
			'20 créditos y un mes de suscripción afro.',
			'10 créditos y un mes de suscripción afro.',
			'45 monedas web y un mes de suscripción afro.',
			'40 monedas web y un mes de suscripción afro.',
			'35 monedas web y un mes de suscripción afro.',
			'30 monedas web y un mes de suscripción afro.',
			'25 monedas web y un mes de suscripción afro.',
			'20 monedas web y un mes de suscripción afro.',
			'15 monedas web y un mes de suscripción afro.'
		];

		Api.get('/ranking/top10', {}, function (r) {
			if (r.total>0) {

				$('#topEvents').append(
					`<div class="box box-big box-yellow animated bounceInUp">
						<div class="head">Clasificacion mensual <span class="glyphicons glyphicons-podium"></span></div>
						<div class="body" style="padding:5px;">
							<div id="winnersEvent"></div>
						</div>
					</div>`
				);


				for (var i = 0; i < r.data.length; i++) {
					$('#winnersEvent').append(
						`<div class="account-box">
	                    	<div class="avatar" style="background-image:url(${r.data[i].user.avatar});">
	                    		<a href="/${r.data[i].user.username}"></a>
	                    	</div>
	                    	<div class="body">
	                        	<span>
	                        	    <h1><a href="/${r.data[i].user.username}">${r.data[i].user.name}</a></h1> <i>${r.data[i].user.nick}</i>
	                        	    <h2>${r.data[i].score} puntos</h2>
	                        	</span>
	                    	</div>
	                    	<div class="button orange right" rel="tooltip" data-name="${i+1} lugar" data-description="${prizes[i]}" style="margin:11px;"><span class="glyphicons glyphicons-cup"></span>${i+1}</div>
	                	</div>
						`
					);
				}

			}
		});
	},

	search: function(s_month, s_year) {
				var prizes = [
			'30 créditos, 50 monedas web y logro exclusivo.',
			'20 créditos y un mes de suscripción afro.',
			'10 créditos y un mes de suscripción afro.',
			'45 monedas web y un mes de suscripción afro.',
			'40 monedas web y un mes de suscripción afro.',
			'35 monedas web y un mes de suscripción afro.',
			'30 monedas web y un mes de suscripción afro.',
			'25 monedas web y un mes de suscripción afro.',
			'20 monedas web y un mes de suscripción afro.',
			'15 monedas web y un mes de suscripción afro.'
		];

		Api.get('/ranking/old', {
			month: s_month,
			year: s_year
		}, function (r) {
			if (r.total>0) {

				$('#topEvents').append(
					`<div class="box box-big box-yellow animated bounceInUp">
						<div class="head">Clasificacion <span class="glyphicons glyphicons-podium"></span></div>
						<div class="body" style="padding:5px;">
							<div id="winnersEvent"></div>
						</div>
					</div>`
				);


				for (var i = 0; i < r.data.length; i++) {
					$('#winnersEvent').append(
						`<div class="account-box">
	                    	<div class="avatar" style="background-image:url(${r.data[i].user.avatar});">
	                    		<a href="/${r.data[i].user.username}"></a>
	                    	</div>
	                    	<div class="body">
	                        	<span>
	                        	    <h1><a href="/${r.data[i].user.username}">${r.data[i].user.name}</a></h1> <i>${r.data[i].user.nick}</i>
	                        	    <h2>${r.data[i].score} puntos</h2>
	                        	</span>
	                    	</div>
	                    	<div class="button orange right" rel="tooltip" data-name="${i+1} lugar" data-description="${prizes[i]}" style="margin:11px;"><span class="glyphicons glyphicons-cup"></span>${i+1}</div>
	                	</div>
						`
					);
				}

			}
		});
	}
}
